import { saveQuote } from "../../action/share_screen/screenShare.action";
import { const_var, params } from "../../redux/reducers/reducer";
import { addDiscountExclusionsInPayload, checkAdditionalChargesData, checkBuildingTypeCategory, detectDeviceInfo, extraAddOnRoofPitchPayload, setExtraOptionsVariables, updateDocOnSave } from "../../redux/reducers/utils";
import { createUpdateService } from "../../services/quote-order.service";
import { cleanPayload } from "../../utils/commonUtils";

function setLeantoAlignments(post_data, params, const_var) {
	if (post_data?.building?.leanto?.length > 0) {
		for (let i = 0; i <= post_data["building"].leanto.length - 1; i++) {
			if (post_data["building"].leanto[i].leanto_type == 1) {
				if (params.leanStyle.left === "gable" && params.p_d == params.lean_p_w) {
					post_data["building"].leanto[i].alignment = "center";
				} else {
					post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 2) {
				if (params.leanStyle.right === "gable" && params.p_d == params.leanR_p_w) {
					post_data["building"].leanto[i].alignment = "center";
				} else {
					post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 3) {
				if (params.leanStyle.front === "gable" && params.p_w == params.leanF_p_w) {
					post_data["building"].leanto[i].alignment = "center";
				} else {
					post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 4) {
				if (params.leanStyle.back === "gable" && params.p_w == params.leanB_p_w) {
					post_data["building"].leanto[i].alignment = "center";
				} else {
					post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
				}
			}
		}
	}
}

export function submitBuildingData() {
	return (dispatch, getState) => {
		setLeantoAlignments(const_var.post_data, params, const_var);
		if (const_var?.post_data?.building?.other_building_type_name == "") {
			params.other_building_type_name = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
			const_var.post_data["building"].other_building_type_name = params.other_building_type_name;
			const_var.post_data["building"].name = params.other_building_type_name;
		}
		const_var.post_data["building"].building_type_name = const_var.post_data["building"].other_building_type_name;
		const_var.post_data["name"] = const_var.post_data["building"].other_building_type_name;

		if (const_var?.crmSetting?.is_zipcode_screen == true) {
			const_var.post_data["building"].state_mfg_zipcode = const_var.state_mfg_zipcode;
		}
		const discountAmount = const_var?.post_data?.building?.discount_amount;
		if (discountAmount == undefined || discountAmount == 0) {
			const_var.manufacturer_discount_label = "";
			const_var.post_data["building"].manufacturer_discount_label = "";
		}
		if (const_var?.manufacturer_discount_label) {
			const_var.post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label;
		}
		addDiscountExclusionsInPayload(const_var);
		const_var.post_data["building"].installationsurfaceChange = true;
		const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee;
		const_var.post_data["building"].is_showBackgroundImage = const_var.crmSetting.is_show_background;
		const_var.post_data["building"].custom_building = const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" ? 1 : const_var.hide_price_calculation;
		const_var.post_data["building"].custom_distance_on_center = params.oncenter_val_with_action != "" ? params.oncenter_val_with_action : "";
		const_var.post_data["building"].payment_mode = const_var.paymentOptionObj[params.paymentmode];
		const_var.post_data["user_id"] = const_var.crmSetting.login_user_id;
		const_var.post_data["is_quote"] = 1;
		const_var.post_data["questions"] = const_var.estimator_QuestionAnswer;
		const_var.post_data["charge_card"] = 0;
		const_var.post_data["form_type"] = "3d_v4";
		const_var.post_data["created_source"] = "3d_v4";
		const_var.post_data["is_api"] = 1;
		const_var.post_data["referral_source"] = const_var.referrer;
		const_var.post_data["source"] = const_var.crmSetting.source;
		const_var.post_data["build_type"] = "added_building";
		const_var.post_data["page"] = const_var.crmSetting.page;
		const_var.post_data["form"] = "Quote Form";
		const_var.post_data["api_token"] = const_var.crmSetting.api_token;
		const_var.post_data["building_update"] = true;
		const_var.post_data["pdf_price_breakdown"] = const_var.order_extra_items["pdf_price_breakdown"];
		const_var.post_data["module"] = const_var.crmSetting.is_module_name;
		const_var.post_data["module_id"] = const_var.crmSetting.is_module_id;
		const_var.post_data["sub_module"] = const_var.crmSetting.sub_module;
		const_var.post_data["sub_module_id"] = const_var.crmSetting.sub_module_id;
		const_var.post_data["in_app"] = 1;
		const_var.post_data["building_data"] = const_var.SendAPIBuildingData;
		const_var.post_data["pricing_data"] = const_var.isLTBuilding ? const_var.holdPricingResponse : const_var.a_p_d_a;
		const_var.post_data["building_data"]["color_data"] = const_var?.color;
		const_var.post_data["building_data"]["component_data"] = const_var.componentData;
		const_var.post_data["building_data"]["siding_material_data"] = const_var.mainSidingOptions;
		const_var.post_data["is_generate_pdf"] = true;
		const_var.post_data["building"]["card_processing_fee"] = const_var.card_processing_fee;

		const_var.post_data["building"]["storage_position"] = {
			endStoragePositionZ: params.endStoragePositionZ,
			leftLeanStoragePosition: params.leftLeanStoragePosition,
			rightLeanStoragePosition: params.rightLeanStoragePosition,
			frontLeanStoragePosition: params.frontLeanStoragePosition,
			backLeanStoragePosition: params.backLeanStoragePosition
		};

		let check_type_category = checkBuildingTypeCategory(const_var.post_data.building.default_building_image_name);
		const_var.post_data["building"].building_category = check_type_category.type;
		const_var.post_data["building"].building_subcategory = check_type_category.name;

		const_var.additionalChargeArr = checkAdditionalChargesData();
		const_var.post_data["building"].AdditionalCharges = const_var.additionalChargeArr;
		const_var.post_data["building_data"]["component_data"] = const_var.componentData;

		const_var.post_data.building.selectedBuildingUniqueId = const_var.selectedBuildingUniqId;

		if (const_var?.editAPIDataByResponse?.data?.main_created_at != undefined) {
			const responseData = const_var?.editAPIDataByResponse?.data;
			const_var.post_data.building.create_at_date = responseData?.request_data?.building?.create_at_date ?? responseData?.main_created_at;
			const_var.post_data.main_created_at = responseData?.main_created_at;
		}

		const_var.post_data["building"].additional_note = params.additional_note;
		if (params.p_c_i && const_var?.post_data?.building) {
			const_var.post_data.building.insulation = "custom";
		}
		if ((const_var.post_data?.building?.insulation == "full" || const_var.post_data?.building?.insulation == "roof_only") && const_var.post_data?.building?.leanto?.length > 0) {
			const_var.post_data?.building?.leanto.forEach((lean) => {
				delete lean.insulation;
				delete lean.insulation_type;
				delete lean.insulation_price;
			});
		}
		const_var.post_data.building.is_edit_extra_labour = const_var.is_edit_extra_labour || false;
		const_var.post_data["building"]["device_details"] = detectDeviceInfo();
		const_var.post_data["building"].isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;
		const_var.post_data["building"].wallOrientation = params.wallOrientation;
		if (const_var.isLTBuilding) {
			const_var.post_data["building"].selectedBracingForAddedBuilding = const_var.selectedBracingForAddedBuilding;
		}

		// extraAddOnRoofPitchPayload();
		updateDocOnSave();
		if (params.m_s_n == 3 && const_var.post_data?.building_data?.building?.length > 0 && const_var.post_data?.building?.engineer_drawings_name != "None") {
			const_var.post_data.building_data.building.forEach((building, index) => {
				if (building.drawings?.length > 0) {
					let findNoneIndex = building.drawings.findIndex((obj) => obj?.name.toLowerCase() == "none");
					if (findNoneIndex > -1) {
						const_var.post_data.building_data.building[index].drawings.splice(findNoneIndex, 1);
					}
				}
			});
		}
		setExtraOptionsVariables(const_var);
		if (const_var.crmSetting.is_module_name == "inventory") {
			const_var.post_data["product_name"] = const_var.post_data["building"].other_building_type_name;
			const_var.post_data["status"] = params.display_product_status;
			const_var.post_data["description"] = const_var.order_extra_items["description"] != undefined ? const_var.order_extra_items["description"] : "";
			const_var.post_data["imageDataLayout"] = const_var.twodImageData;

			if (const_var?.dealer_discount_label) {
				const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label;
			}

			const_var.post_data["building"].electricity = "";
			const_var.post_data["building"].surface_level = "";
			const_var.post_data["building"].job_site_level = "";
			const_var.post_data["building"].inside_city = "";
			const_var.post_data["building"].installation_ready = "";
			const_var.post_data["building"].notched_lip = "";
			const_var.post_data["building"].welded_spacer = "";
			const_var.post_data["building"].space_around_building = "";
			const_var.post_data["building"].site_clear_obstacle = "";
			const_var.post_data["building"].lifttype_price = 0;

			const_var.post_data["building"]["order_extra_items"].electricity = "";
			const_var.post_data["building"]["order_extra_items"].surface_level = "";
			const_var.post_data["building"]["order_extra_items"].job_site_level = "";
			const_var.post_data["building"]["order_extra_items"].inside_city = "";
			const_var.post_data["building"]["order_extra_items"].installation_ready = "";
			const_var.post_data["building"]["order_extra_items"].notched_lip = "";
			const_var.post_data["building"]["order_extra_items"].welded_spacer = "";
			const_var.post_data["building"]["order_extra_items"].space_around_building = "";
			const_var.post_data["building"]["order_extra_items"].site_clear_obstacle = "";

			const payload = cleanPayload(structuredClone(const_var.post_data));
			let request = createUpdateService(const_var.crmSetting.form_action, const_var.crmSetting.is_module_name, payload, const_var.crmSetting.is_module_id);
			return request
				.then((response) => {
					const_var.post_data["module_id"] = response.data.id;
					getState()?.screenShareReducer?.isSharingScreen && dispatch(saveQuote(response.data));
					const element = document.getElementsByClassName("spinner-active")[0];
					element.classList.remove("spinner-active");
					response.data.redirect_url = `${const_var.crmSetting.web_url}/inventories`;
					window.location.href = response.data.redirect_url;
				})
				.catch(function (error) {
					console.log(error);
				});
		} else {
			if (const_var.post_data["building"].surcharge_amount != 0) {
				const_var.post_data["building"].surcharge_taxable = const_var.post_data["building"].surcharge_taxable == undefined ? 0 : const_var.post_data["building"].surcharge_taxable;
			}
			if (const_var.dealer_discount_label != undefined && const_var.dealer_discount_label != "" && parseFloat(const_var.post_data["building"].discount_amount) > 0) {
				const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label;
			}

			if (const_var.LeadCustomerData != undefined && const_var.LeadCustomerData.email != undefined && const_var.LeadCustomerData.email != "") {
				let emailTest = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
				if (emailTest.test(const_var.LeadCustomerData.email)) {
					const_var.LeadCustomerData.email = const_var.LeadCustomerData.email;
				} else {
					const_var.LeadCustomerData.email = "";
				}
			}
			const_var.post_data = { ...const_var.post_data, ...const_var.LeadCustomerData };

			if (const_var.post_data["mobile_no"] == undefined) {
				const_var.post_data["mobile_no"] = const_var.post_data["phone_no"];
			}

			const_var.post_data["zipCode"] = const_var.zipCode;
			const_var.post_data["billing_county"] = const_var.post_data.billing_country;
			const_var.post_data["shipping_county"] = const_var.post_data.shipping_country;

			if (const_var.crmSetting.is_CRM == undefined || const_var.crmSetting.is_CRM == false) {
				const_var.post_data["company_id"] = params.company_id;
				const_var.post_data["estimator_domain"] = const_var.crmSetting.main_domain_url;
			}

			const payload = cleanPayload(structuredClone(const_var.post_data));
			let request = createUpdateService(const_var.crmSetting.form_action, const_var.crmSetting.is_module_name, payload, const_var.crmSetting.is_module_id);
			return request
				.then(async (response) => {
					getState()?.screenShareReducer?.isSharingScreen && dispatch(saveQuote(response.data));
					const_var.post_data["module_id"] = response.data.id;

					if (const_var.loginSession == true && const_var.crmSetting.is_module_name == "quote" && const_var.crmSetting.api_token == "wjL4vCj5QrxGT2oC9Mv40N72XZ47TUJp52ONOcpMRaW7XDlNMpij4vLrIoHk6CAJ") {
						let URLkeens = "https://hooks.zapier.com/hooks/catch/16508503/2tlkngj/";
						let sub_order_total_keen = const_var.BuildingPriceArrar["sub_order_total"] !== undefined ? const_var.BuildingPriceArrar["sub_order_total"] : 0;
						let payload = {
							first_name: const_var.post_data.first_name,
							last_name: const_var.post_data.last_name,
							email: const_var.post_data.email || "",
							phone: const_var.post_data.phone_no || "",
							installation_zip: const_var.post_data?.address?.[0]?.zipcode || "",
							deal_name: `${const_var.post_data.building.length}X${const_var.post_data.building.width}X${const_var.post_data.building.height} ${const_var.post_data.building.building_type_name} ${response.data.quote_string}`,
							product_type: "Metal Building/Carport",
							building_type: const_var.post_data.building.building_type_name,
							building_width: const_var.post_data.building.width,
							building_length: const_var.post_data.building.length,
							building_height: const_var.post_data.building.height,
							framing_gauge: `${const_var.post_data.building.gauge} Gauge`,
							building_certification: const_var.post_data.building.certificate_name,
							building_manufacture: const_var.post_data.building.manufacturer_name,
							installation_surface: const_var.post_data.building.installation_surface,
							roof_style: const_var.post_data.building.roof_style_name,
							roof_pitch: const_var.post_data.building.roof_pitch,
							roof_color: const_var.post_data.building.roof_color.name,
							trim_color: const_var.post_data.building.trim_color.name,
							wall_color: const_var.post_data.building.wall_color.name,
							wainscot_color: const_var.post_data.building.wainscot !== undefined ? const_var.post_data.building.wainscot.name : "",
							components: "",
							building_quote: response.data.pdf_url,
							building_msrp: 0,
							manufacturer_discount: const_var.post_data["building"].discount_amount,
							subtotal: sub_order_total_keen,
							quote_id: response.data.quote_string,
							deal_id: response.data.quote_string,
							questions: const_var.post_data.questions
						};
						try {
							const res = await fetch(URLkeens, {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: JSON.stringify(payload),
								mode: "no-cors"
							});
							if (!res.ok) {
								throw new Error("Network res was not ok");
							}
							const resp = await res.json();
							console.log(resp);
						} catch (error) {
							console.log("There was a problem with the fetch operation:", error);
						}
					}

					if (response.data.status == true) {
						const_var.crmSetting.is_module_id = response.data.id;
						const_var.crmSetting.is_Action_url = "order/update";
					}
					if (response.data.status == true || response.data.status == false) {
						dispatch({ type: "GenrateBuildingDatatoServer", event: "", key: "", returnRespone: response.data });
						const element = document.getElementsByClassName("spinner-active")[0];
						element.classList.remove("spinner-active");
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};
}
